module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Qacuta/Nagano_Qacuta_MIROC5_RCP26_Mid.png";